import { Toggle } from '@augmentt-dev/ui-components'
import clsx from 'clsx'
import { Field } from 'formik'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './FormikToggleSwitch.module.scss'

const propTypes = {
  /**
   * id of the field. The id passed is also bound to the field's name
   */
  id: PropTypes.string.isRequired,
  /**
   * class to override default styles
   */
  className: PropTypes.string,
  /**
   * If exists, calls it with the value for custom additional actions
   * Formik setFieldValue will always run before it
   */
  onChange: PropTypes.func,
}

/**
 * Connects a Toggle (switch) component with Formik
 */
function FormikToggleSwitch(props) {
  const { id, className = '', onChange = null, ...rest } = props ?? {}

  return (
    <Field name={id}>
      {({ field, form }) => (
        <span className={clsx(styles.toggleSwitchWrapper, className)}>
          <Toggle
            {...rest}
            id={id}
            checked={field.value === true}
            onChange={(value) => {
              form.setFieldValue(id, value)
              if (onChange) {
                onChange(value)
              }
            }}
          />
        </span>
      )}
    </Field>
  )
}

FormikToggleSwitch.propTypes = propTypes

export default FormikToggleSwitch
